module.exports = __webpack_public_path__ + "static/uri gneezy-5ce391e7f529a6a70566169d1d1a438b.png";